import { KeyboardArrowLeftRounded, KeyboardArrowRightRounded } from "@material-ui/icons";
import { useStyles } from "@webapps/styles";
import { Button } from '@material-ui/core';
import { cx } from '@emotion/css';

const Pagination = ({ currentPage, setCurrentPage, totalPages, style }) => {
    const { classes } = useStyles(styles);
    const isDisableBack = currentPage === 1
    const isDisableNext = currentPage === totalPages

    function getPaginationNumbers(currentPage, totalPages, maxPages = 7) {
        const pageNumbers = [];
        const ellipsis = '...';

        if (totalPages <= maxPages) {
            // Moins de maxPages pages : on affiche tout
            for (let i = 1; i <= totalPages; i++) {
                pageNumbers.push(i);
            }
            return pageNumbers.length === 0 ? [1] : pageNumbers;
        }

        const sidePages = 2; // Nombre de pages à afficher avant/après la page courante (hors début/fin)

        // Début du tableau
        if (currentPage <= sidePages + 1) {
            // Exemple : 1 2 3 4 5 ... 10
            for (let i = 1; i <= maxPages - 2; i++) {
                pageNumbers.push(i);
            }
            pageNumbers.push(ellipsis);
            pageNumbers.push(totalPages);
            return pageNumbers.length === 0 ? [1] : pageNumbers;
        }

        // Fin du tableau
        if (currentPage >= totalPages - sidePages) {
            // Exemple : 1 ... 6 7 8 9 10
            pageNumbers.push(1);
            pageNumbers.push(ellipsis);
            for (let i = totalPages - (maxPages - 3); i <= totalPages; i++) {
                pageNumbers.push(i);
            }
            return pageNumbers.length === 0 ? [1] : pageNumbers;
        }

        // Milieu du tableau
        // Exemple : 1 ... 5 6 7 ... 10
        pageNumbers.push(1);
        pageNumbers.push(ellipsis);
        for (let i = currentPage - 1; i <= currentPage + 1; i++) {
            pageNumbers.push(i);
        }
        pageNumbers.push(ellipsis);
        pageNumbers.push(totalPages);

        return pageNumbers.length === 0 ? [1] : pageNumbers;
    }


    const paginationNumbers = getPaginationNumbers(currentPage, totalPages, 7);

    return (
        <div className={classes.container} style={style}>
            <KeyboardArrowLeftRounded
                className={isDisableBack ? classes.inactiveArrow : classes.activeArrow}
                onClick={() => { isDisableBack || setCurrentPage((prev) => Math.max(1, prev - 1)) }}
            />
            {paginationNumbers.map((page, index) => (
                <Button
                    key={index}
                    className={cx(
                        page === currentPage ? classes.activePaginationButton : classes.inactivePaginationButton
                    )}
                    onClick={() => setCurrentPage(page)}
                    disabled={page === '...'} // Désactiver les boutons "..."
                >
                    <div className={page === currentPage ? classes.activePaginationText : classes.inactivePaginationText}>
                        {page}
                    </div>
                </Button>
            ))}
            <KeyboardArrowRightRounded
                className={isDisableNext ? classes.inactiveArrow : classes.activeArrow}
                onClick={() => { isDisableNext || setCurrentPage((prev) => Math.min(totalPages, prev + 1)) }}
            />
        </div>
    );
}

const styles = ({ }) => ({
    "container": {
        alignItems: "center",
        display: "flex",
        flexDirection: "row",
        height: "min-content",
        justifyContent: "end",
        width: "100%",
        gap: "6px",
        overflow: "hidden",
    },
    "inactiveArrow": {
        height: "24px",
        width: "24px",
        fill: "#92abd2",
        cursor: "default",
    },
    "activeArrow": {
        height: "24px",
        width: "24px",
        fill: "#5d75a8",
        cursor: "pointer",
    },
    "activePaginationButton": {
        alignContent: "center",
        borderRadius: "30px",
        display: "flex",
        flexDirection: "row",
        height: "24px",
        width: "24px",
        cursor: "default",
        placeItems: "center",
        "&:hover": {
            backgroundColor: "#ffffff",
        },
    },
    "activePaginationText": {
        fontFamily: "\"Montserrat\", sans-serif",
        fontSize: "12px",
        fontWeight: "500",
        lineHeight: "12px",
        textAlignment: "center",
        color: "#152652",
    },
    "inactivePaginationButton": {
        borderBottomWidth: "1px",
        borderColor: "#c0d9ff",
        borderLeftWidth: "1px",
        borderRightWidth: "1px",
        borderStyle: "solid",
        borderTopWidth: "1px",
        alignContent: "center",
        backgroundColor: "#ffffff",
        borderBottomLeftRadius: "30px",
        borderBottomRightRadius: "30px",
        borderTopLeftRadius: "30px",
        borderTopRightRadius: "30px",
        display: "flex",
        flexDirection: "row",
        height: "24px",
        width: "24px",
        placeItems: "center",
        "&:hover": {
            borderColor: "#0060F9",
            backgroundColor: "#ffffff",

            "div": {
                color: "#152652",
            }
        },
    },
    "inactivePaginationText": {
        fontFamily: "\"Montserrat\", sans-serif",
        fontSize: "12px",
        fontWeight: "500",
        lineHeight: "12px",
        textAlignment: "center",
        color: "#5d75a8",
    },
})
export default Pagination;    